module.exports = __webpack_public_path__ + "img/jordbaertaerte_skaaret.82dce21e.jpg";